import { z } from 'zod';
import { propertySchema } from '../property/index.js';
export var LoanStatusEnum;
(function (LoanStatusEnum) {
    LoanStatusEnum["AVAILABLE"] = "available";
    LoanStatusEnum["DRAFT"] = "draft";
    LoanStatusEnum["HOLD"] = "hold";
    LoanStatusEnum["PENDING"] = "pending";
    LoanStatusEnum["REMOVED"] = "removed";
    LoanStatusEnum["DELETED"] = "deleted";
    LoanStatusEnum["FUNDED"] = "funded";
    LoanStatusEnum["PAID"] = "paid";
    LoanStatusEnum["PROCESS"] = "process";
    LoanStatusEnum["UNKNOWN"] = "unknown";
})(LoanStatusEnum || (LoanStatusEnum = {}));
export const mortgageSchema = propertySchema
    .omit({
    totalUnits: true,
    propertyType: true,
    purchasePrice: true,
    propertyClass: true,
    propertyStatus: true,
})
    .extend({
    loanId: z.string(),
    loanStatus: z.enum(LoanStatusEnum),
    price: z.number().optional(),
    position: z.number().optional(),
    yield: z.number().optional(),
});
